var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.53674e-07H32V32H0V-9.53674e-07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 30.6667H6.66658C3.72125 30.6667 1.33325 28.2787 1.33325 25.3334V12.0001C1.33325 9.05475 3.72125 6.66675 6.66658 6.66675H14.6666C17.6119 6.66675 19.9999 9.05475 19.9999 12.0001V25.3334C19.9999 28.2787 17.6119 30.6667 14.6666 30.6667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5258 28.0007C22.2552 28.6727 25.0978 27.0914 25.9112 24.3234L30.4485 10.4994C31.2725 7.69674 29.6885 4.75408 26.8965 3.89675L19.3152 1.57008C16.5178 0.711411 13.5525 2.26608 12.6658 5.05408L12.1045 6.66741",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6668C11.8613 14.6668 10.6666 15.8615 10.6666 17.3335C10.6666 15.8615 9.47192 14.6668 7.99992 14.6668C6.52792 14.6668 5.33325 15.8615 5.33325 17.3335C5.33325 19.2668 7.39192 21.8548 8.95192 23.1708C9.94258 24.0082 11.3906 24.0082 12.3813 23.1708C13.9413 21.8548 15.9999 19.2668 15.9999 17.3335C15.9999 15.8615 14.8053 14.6668 13.3333 14.6668Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrash);
export default __webpack_public_path__ + "static/media/crash.877e979efebb78c5473035fa163d1a68.svg";
export { ForwardRef as ReactComponent };